import { ScheduleLifecyclePeriodLockedError } from "@common/schemas/domains/accounting/scheduleLifecycle.schema";
import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";
import { useSettings } from "@components/settings/SettingsProvider";
import { WorkspaceSettingsPages } from "@components/settings/constants";
import {
    SCHEDULE_LOCKED_PERIODS_CANCEL_LABEL,
    SCHEDULE_LOCKED_PERIODS_GO_TO_LOCKS_LABEL,
    SCHEDULE_LOCKED_PERIODS_TITLE,
    buildScheduleLockedPeriodsBody,
} from "./scheduleLockedPeriodsCopy";

interface ScheduleLockedPeriodsModalProps {
    show: boolean;
    error: ScheduleLifecyclePeriodLockedError;
    onHide: () => void;
}

/**
 * Shown when apply or a lifecycle action is refused because a journal entry
 * it would write, reverse or delete falls in a locked period. Locks live on
 * the workspace Locks page, one row per entity, so "Go to locks" opens it.
 */
export const ScheduleLockedPeriodsModal = ({
    show,
    error,
    onHide,
}: ScheduleLockedPeriodsModalProps) => {
    const { open: openSettings } = useSettings();

    return (
        <ConfirmationModal
            show={show}
            title={SCHEDULE_LOCKED_PERIODS_TITLE}
            question={buildScheduleLockedPeriodsBody(error)}
            yes={SCHEDULE_LOCKED_PERIODS_GO_TO_LOCKS_LABEL}
            no={SCHEDULE_LOCKED_PERIODS_CANCEL_LABEL}
            onConfirm={() => {
                onHide();
                openSettings([WorkspaceSettingsPages.LOCKS]);
            }}
            onReject={onHide}
            onHide={onHide}
        />
    );
};
